export default function UrgencyBar() {
  return (
    <div className="w-full py-2.5 px-4 text-center" style={{ background: 'var(--footer-bg)' }}>
      <p className="text-sm font-medium" style={{ color: 'var(--footer-accent)', fontFamily: "'DM Sans', sans-serif" }}>
        <span className="mr-2 opacity-80">♪</span>
        Entrega prioritária em até{' '}
        <strong style={{ color: '#FFFFFF' }}>30 minutos</strong>
        <span className="mx-2 opacity-40">·</span>
        Surpreenda alguém especial agora mesmo
        <span className="ml-3 hidden sm:inline-block px-3 py-0.5 rounded-full text-xs font-semibold" style={{ background: 'var(--gold)', color: '#fff' }}>
          a partir de R$ 34,90
        </span>
      </p>
    </div>
  );
}
